/**
 * LBRGT price style: a reduced price is red and carries a badge with the saving.
 *
 * The badge shows exactly the difference between the two prices next to it, read from the page
 * rather than from the variant: on the Merino page Kaching's custom JS (app setting, not in the
 * theme) writes the set price and the struck-through price into .price__default without touching
 * compare_at, so variant data alone never sees a set as reduced (acceptance call 22.10.: red price
 * and "40,08 € Rabatt" as in Figma). Kaching per item or set total - the badge follows whatever is
 * shown.
 */
(() => {
  // Shopify money format placeholders -> thousands separator, decimal separator, decimals
  const FORMATS = {
    amount: [',', '.', 2],
    amount_no_decimals: [',', '.', 0],
    amount_with_comma_separator: ['.', ',', 2],
    amount_no_decimals_with_comma_separator: ['.', ',', 0],
    amount_with_apostrophe_separator: ["'", '.', 2],
    amount_with_space_separator: [' ', ',', 2],
  };

  const money = (cents, format) => (format || '{{amount_with_comma_separator}} €')
    .replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      const [thousands, decimal, places] = FORMATS[key] || FORMATS.amount_with_comma_separator;
      const [int, frac] = (cents / 100).toFixed(places).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    });

  // "56<sup>63</sup> €", "69,99 €", "CHF 160.20" -> cents. Without decimals (html.lbrgt-no-cents)
  // Kaching's split at the thousands separator is not a cents part.
  const toCents = (el) => {
    if (!el) return 0;
    let text = el.innerHTML.replace(/<sup[^>]*>/i, '|').replace(/<[^>]*>/g, '');
    if (!text.includes('|')) text = text.replace(/[.,](\d{2})(?!\d)/, '|$1');
    const [int = '', frac = ''] = text.replace(/[^\d|]/g, '').split('|');
    if (document.documentElement.classList.contains('lbrgt-no-cents')) return Number(int + frac) * 100;
    return Number(int || 0) * 100 + Number((frac + '00').slice(0, 2));
  };

  const init = (root) => {
    if (root.dataset.lbrgtPriceInit) return;
    root.dataset.lbrgtPriceInit = 'true';

    // Elements are looked up on every pass: the variant picker may replace parts of the block
    const sync = () => {
      const price = root.querySelector('.price');
      const box = root.querySelector('.price__default');
      const badge = root.querySelector('[data-lbrgt-badge]');
      if (!price || !box || !badge) return;
      const current = toCents(box.querySelector('.price__current .js-value'));
      const was = box.querySelector('.price__was .js-value');
      const wasWrap = box.querySelector('.price__was');
      const shown = !box.hidden && wasWrap && wasWrap.style.display !== 'none' && was && was.textContent.trim() !== '';
      const full = shown ? toCents(was) : 0;
      const reduced = current > 0 && full > current;

      price.classList.toggle('lbrgt-price--reduced', reduced);
      if (reduced) {
        const saving = full - current;
        const text = badge.dataset.format
          .split('[percent]').join(String(Math.round((saving * 100) / full)))
          .split('[saving]').join(money(saving, badge.dataset.moneyFormat));
        if (badge.textContent !== text) badge.textContent = text;
      }
      // Only write what changed - the observer below also sees our own writes
      if (badge.hidden === reduced) badge.hidden = !reduced;
    };

    new MutationObserver(sync).observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'hidden'],
    });
    sync();
  };

  document.querySelectorAll('.lbrgt-price .product-info__price').forEach(init);
})();
